import { render, staticRenderFns } from "./ExpenseInvestigationOnboarding.vue?vue&type=template&id=88fd8036&scoped=true&"
import script from "./ExpenseInvestigationOnboarding.vue?vue&type=script&lang=js&"
export * from "./ExpenseInvestigationOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./ExpenseInvestigationOnboarding.vue?vue&type=style&index=0&id=88fd8036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88fd8036",
  null
  
)

export default component.exports